import './styles.scss';
import { registerFragment } from '@neptune/cx/registry';
import { DisposalSet } from '@neptune/cx/utils';

const gc = new DisposalSet();

registerFragment('chroa-social-sharing', (fragmentElement, config, meta) => {
    /* toggle for share btn */
    const shareContainer = document.querySelector('.chroa-social-share');
    const shareToggleBtn = document.getElementById('chroa-social-share-button')
    const drawerContainer = document.querySelector('.chroa-social-share__drawer');

    shareToggleBtn?.addEventListener('click', (e: Event) => {
        e.preventDefault();
        drawerContainer?.classList.toggle('chroa-social-share__drawer--open');
        shareToggleBtn?.setAttribute('aria-expanded', (drawerContainer?.classList.contains('chroa-social-share__drawer--open') ? 'true' : 'false'))
        drawerContainer?.setAttribute('aria-hidden', (drawerContainer?.classList.contains('chroa-social-share__drawer--open') ? 'false' : 'true'))
    })

    /* dynamic hrefs for sharing */
    let pageTitle = document.querySelector('h1')?.textContent;
    if (!pageTitle) {
        pageTitle = document.querySelector('title')?.textContent;
    }
    if (!pageTitle) return;

    let encodedURL = encodeURIComponent(window.location.href);
    let encodedPageTitle = encodeURIComponent(pageTitle);

    const socialIconElements = document.querySelectorAll('.chroa-social-share__item__icon')

    socialIconElements.forEach((el => {
        let href = el.getAttribute('href');
        if (href) {
            href = href?.replace('[post-url]', encodedURL);
            href = href?.replace('[post-title]', encodedPageTitle);
            el.setAttribute('href', href);
        }
    }));

    /* Check for dynamic Styles (chroa-article-banner__backdrop-image) */
    const backdropArticleBanner = document.querySelector('.chroa-article-banner__backdrop-image');
    if (backdropArticleBanner !== null) {
        shareContainer?.classList.add('chroa-social-share--white')
    }
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
